import { render, staticRenderFns } from "./PreliminaryPsd2Sync.vue?vue&type=template&id=985ac7c2&scoped=true&"
import script from "./PreliminaryPsd2Sync.vue?vue&type=script&lang=js&"
export * from "./PreliminaryPsd2Sync.vue?vue&type=script&lang=js&"
import style0 from "./PreliminaryPsd2Sync.vue?vue&type=style&index=0&id=985ac7c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985ac7c2",
  null
  
)

export default component.exports